import React, { useState } from 'react';

import { TimeRangePicker } from 'Components/organisms/TimePicker';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function TimePickerRangeComponents() {
  const [minHour, setMinHour] = useState(2);
  const [inputexist, setInputexist] = useState(true);
  const [time, setTime] = useState(undefined);
  return (
    <div className={cx('time-picker-range')}>
      최소 진행시간:{' '}
      <input
        placeholder="최소 진행시간"
        value={minHour}
        onChange={(e) => {
          setMinHour(e.target.value);
        }}
      />
      <br />
      {/* <button onClick={() => setInputexist(!inputexist)}>
        input
        <span style={{ fontWeight: inputexist && 700 }}>여</span>/
        <span style={{ fontWeight: !inputexist && 700 }}>부</span>
      </button> */}
      <TimeRangePicker
        minCheckTime={minHour}
        inputExist={inputexist}
        ChangeHandler={(value) => setTime(value)}
        timeValue={11}
        TimeFormat={'a hh시 mm분'}
      />
    </div>
  );
}
export default TimePickerRangeComponents;

export const path = '/time_picker_range';
